import { ColumnTypeEnum } from '@y42/json-schema';

export class ContentfulGroupedItem<T> {
  constructor(
    public name = '',
    public icon = '',
    public items: T[] = [],
    public color = '',
    public variable_id: ColumnTypeEnum | null = null,
    public order = 0,
  ) {}
  second_group: Array<ContentfulGroupedItem<T>> = [];
}
